<!--
 * @Author: fengxiaojing
 * @LastEditTime: 2022-04-25 14:54:30
 * @Description: 两票集成
 * @LastEditors: Please set LastEditors
-->
<template>
  <el-table class="h-100 w-100 p-r-20" :data="tableData">
    <el-table-column type="expand">
      <template slot-scope="props">
        <el-form label-position="left" inline class="demo-table-expand">
          <el-form-item label="设备名称:">
            <span>{{ props.row.equpmentName }}</span>
          </el-form-item>
          <el-form-item label="设备编号:">
            <span>{{ props.row.equpmentNumber }}</span>
          </el-form-item>
          <el-form-item label="KKS编码:">
            <span>{{ props.row.KKSNumber }}</span>
          </el-form-item>
          <el-form-item label="流水号:">
            <span>{{ props.row.serialNumber }}</span>
          </el-form-item>
          <el-form-item label="工作票号:">
            <span>{{ props.row.workTicketNumber }}</span>
          </el-form-item>
          <el-form-item label="设备专业:">
            <span>{{ props.row.equipmentProfession }}</span>
          </el-form-item>
          <el-form-item label="运行单位:">
            <span>{{ props.row.operatingUnits }}</span>
          </el-form-item>
          <el-form-item label="检修部门:">
            <span>{{ props.row.overhaulDepartment }}</span>
          </el-form-item>
          <el-form-item label="班助:">
            <span>{{ props.row.class }}</span>
          </el-form-item>
          <el-form-item label="填写人:">
            <span>{{ props.row.fillPeople }}</span>
          </el-form-item>
          <el-form-item label="填写时间:">
            <span>{{ props.row.fillTime }}</span>
          </el-form-item>
          <el-form-item label="机组:">
            <span>{{ props.row.unit }}</span>
          </el-form-item>
          <el-form-item label="执行状态:">
            <span>{{ props.row.executionStatus }}</span>
          </el-form-item>
          <el-form-item label="人数共计:">
            <span>{{ props.row.peopleTotal }}</span>
          </el-form-item>
          <el-form-item label="工作负责人:">
            <span>{{ props.row.workHead }}</span>
          </el-form-item>
          <el-form-item label="工作内容:">
            <span>{{ props.row.workContent }}</span>
          </el-form-item>
          <el-form-item label="签发人:">
            <span>{{ props.row.Issuer }}</span>
          </el-form-item>
          <el-form-item label="签发时间:">
            <span>{{ props.row.issuanceDate }}</span>
          </el-form-item>
          <el-form-item label="运行接票人:">
            <span>{{ props.row.recipientTicket }}</span>
          </el-form-item>
          <el-form-item label="接票时间:">
            <span>{{ props.row.PickUpTime }}</span>
          </el-form-item>
          <el-form-item label="批准值长:">
            <span>{{ props.row.approvePeople }}</span>
          </el-form-item>
          <el-form-item label="批准时间:">
            <span>{{ props.row.approveDate }}</span>
          </el-form-item>
          <el-form-item label="批准开始时间:">
            <span>{{ props.row.approveStartDate }}</span>
          </el-form-item>
          <el-form-item label="批准结束时间:">
            <span>{{ props.row.approveEndDate }}</span>
          </el-form-item>
          <el-form-item label="许可人:">
            <span>{{ props.row.licensor }}</span>
          </el-form-item>
          <el-form-item label="许可时间:">
            <span>{{ props.row.licenseTime }}</span>
          </el-form-item>
          <el-form-item label="工作终结人:">
            <span>{{ props.row.workEndPeople }}</span>
          </el-form-item>
          <el-form-item label="终结时间:">
            <span>{{ props.row.endTime }}</span>
          </el-form-item>
        </el-form>
      </template>
    </el-table-column>
    <el-table-column label="流水号" prop="serialNumber" width="120px"></el-table-column>
    <el-table-column label="票号" prop="workTicketNumber"></el-table-column>
    <el-table-column label="工作票类型" prop="workTicketType"></el-table-column>
    <el-table-column label="专业" prop="major"></el-table-column>
    <el-table-column label="创建时间" prop="createdTime" width="150px"></el-table-column>
    <el-table-column label="执行状态" prop="executionStatus"></el-table-column>
  </el-table>
</template>

<script>
export default {
  data() {
    return {
      tableData: [
        {
          equpmentName: '1号机组A循环水泵',
          equpmentNumber: '520033010602000009',
          KKSNumber: '10PAC11AP001',
          serialNumber: 'WTD200517',
          workTicketNumber: 'WTD200517',
          equipmentProfession: '热20200314',
          operatingUnits: '热工',
          overhaulDepartment: '设备部',
          class: '520013_热控班',
          fillPeople: '',
          fillTime: '',
          unit: '1号机组',
          executionStatus: '未执行',
          peopleTotal: '3',
          workHead: '邓轶',
          workContent: '对#1机#1、#2循环水泵冷却水流量开关更换',
          Issuer: '陈丽娟',
          issuanceDate: '2020/3/22 0:00:00',
          recipientTicket: '李嘉鹏',
          PickUpTime: '2020/3/22 0:00:00',
          approvePeople: '袁奥',
          approveDate: '2020/3/22 0:00:00',
          approveStartDate: '',
          approveEndDate: '',
          licensor: '',
          licenseTime: '',
          workEndPeople: '',
          endTime: '',
          workTicketType: '热控工作票',
          major: '热工',
          createdTime: '2020/4/17 16:42:57',
        },
        {
          equpmentName: '1号机组A循环水泵',
          equpmentNumberKKSNumber: '520033010602000009',
          serialNumber: '10PAC11AP001',
          workTicketNumber: 'WTD200520',
          equipmentProfession: '热20200314',
          operatingUnits: '热工',
          overhaulDepartment: '设备部',
          class: '520013_热控班',
          fillPeople: '',
          fillTime: '',
          unit: '1号机组',
          executionStatus: '已终结',
          peopleTotal: '3',
          workHead: '邓轶',
          workContent: '对#1机#1、#2循环水泵冷却水流量开关更换',
          Issuer: '陈丽娟',
          issuanceDate: '2020/3/22 0:00:00',
          recipientTicket: '李嘉鹏',
          PickUpTime: '2020/3/22 0:00:00',
          approvePeople: '袁奥',
          approveDate: '2020/3/22 0:00:00',
          approveStartDate: '',
          approveEndDate: '',
          licensor: '',
          licenseTime: '',
          workEndPeople: '',
          endTime: '',
          workTicketType: '热控工作票',
          major: '热工',
          createdTime: '2020/4/17 16:42:57',
        },
      ],
    }
  },
}
</script>
<style lang="scss" scoped>

.demo-table-expand {
  font-size: 0;
  label {
    width: 90px;
    color: #99a9bf;
  }
  .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    width: 50%;
  }
}

</style>
